import { configureStore } from "@reduxjs/toolkit";
import globalSlices from "./slices/globalSlices";
import {
    useDispatch as useDispatchBase,
    useSelector as useSelectorBase,
} from "react-redux";

/* 
    Creates a store and includes all the slices as reducers
*/
export const store = configureStore({
    reducer: {
        global: globalSlices,
    }
});

export type RootState = ReturnType<typeof store.getState>;

type AppDispatch = typeof store.dispatch;

export const useDispatch = () => useDispatchBase<AppDispatch>();

export const useSelector = <TSelected = unknown>(
    selector: (state: RootState) => TSelected
): TSelected => useSelectorBase<RootState, TSelected>(selector);